import { Spinner } from '../spinner/Spinner.tsx'
import styles from './InfiniteScrollFooter.module.css'

export interface InfiniteScrollFooterProps {
  isLoading: boolean
  hasMore: boolean
  pullDistance?: number
  loadingText?: string
  endText?: string
}

export function InfiniteScrollFooter({
  isLoading,
  hasMore,
  pullDistance = 0,
  loadingText = 'Loading more...',
  endText = "You're all caught up",
}: InfiniteScrollFooterProps) {
  if (!hasMore && !isLoading) {
    return (
      <div className={styles.footer}>
        <span className={styles.endText}>{endText}</span>
      </div>
    )
  }

  return (
    <div
      className={styles.footer}
      style={{
        paddingBottom: pullDistance > 0 ? `${pullDistance}px` : undefined,
        transition: pullDistance > 0 ? 'none' : 'padding-bottom 300ms ease-out',
      }}
    >
      {isLoading ? (
        <div className={styles.loading}>
          <Spinner variant="gradient" size="sm" />
          <span className={styles.loadingText}>{loadingText}</span>
        </div>
      ) : pullDistance > 10 ? (
        <div className={styles.pullHint}>
          <Spinner variant="muted" size="xs" />
          <span className={styles.pullText}>Pull to load more</span>
        </div>
      ) : null}
    </div>
  )
}
